import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import ButtonToIndex from "./ButtonToIndex";

export default function UnreadModalPC({
  open,
  onClose,
  activeType,
  projectIndexUrl,
  jobIndexUrl,
  unreadProjects,
  unreadJobs,
}) {
  const title = activeType === "projects" ? "未読プロジェクト" : "未読求人";
  const items = activeType === "projects" ? unreadProjects : unreadJobs;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          py: "28px",
          px: "68px",
          maxWidth: "764px",
          width: "100%",
          borderRadius: 0,
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            mb: "28px",
            p: 0,
            position: "relative",
          }}
        >
          {title}
        </DialogTitle>
        <IconButton
          sx={{
            width: 60,
            height: 60,
            p: 0,
            fontSize: "30px",
            position: "absolute",
            top: 0,
            right: 0,
            borderRadius: 0,
          }}
          onClick={onClose}
        >
          ×
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, overflow: "hidden" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mb: "28px",
            maxHeight: "400px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {items.length === 0 ? (
            <Typography>
              {activeType === "projects"
                ? "未読のプロジェクトはありません"
                : "未読の求人はありません"}
            </Typography>
          ) : (
            items.map((item) => {
              const href =
                activeType === "projects" ? `/projects/${item.id}` : `/jobs/${item.id}`;

              return (
                <Box
                  key={item.id}
                  component="a"
                  href={href}
                  onClick={onClose}
                  sx={{
                    pt: "29px",
                    pb: "8px",
                    px: "12px",
                    backgroundColor: "#F6F6F7",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#eee" },
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                    borderRadius: 1.5,
                  }}
                >
                  <Typography>{item.title}</Typography>
                  <Typography>{item.price}</Typography>
                  <Typography sx={{ fontSize: "12px", textAlign: "right", mt: "8px" }}>
                    {item.date}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>

        <ButtonToIndex
          activeType={activeType}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
        />
      </DialogContent>
    </Dialog>
  );
}